import { createTheme } from '@mui/material/styles';
import { Theme as SystemTheme } from '@mui/material/styles';

const theme: SystemTheme = createTheme({
  palette: {
    mode: 'dark',
    text: {
      primary: '#F9F9F9',
      secondary: '#BABABA',
      // @ts-expect-error nonselect for the header text
      nonselect: '#808080',
      title: '#E6E6E6',
    },
    success: {
      main: '#38B000',
      light: '#38B00014',
    },
    error: {
      main: '#C44536',
      light: '#C4453614',
    },
    background: {
      default: '#121212',
      paper: '#282828',
    },
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#FC814A',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
      contrastText: '#FFFFFF',
    },
    secondary: {
      light: '#0066ff',
      main: '#FAFAFA',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#333333',
    },
    info: {
      main: '#4f4f4f',
      contrastText: '#F9F9F9',
    },
    info3: {
      main: '#333333',
      dark: '#222222',
      contrastText: '#FFFFFF',
    },
    neutral: {
      main: '#282828',
      light: '#343535',
      contrastText: '#FFFFFF',
    },
    neutral2: {
      main: '#5e5e5e',
    },
    action: {
      disabledBackground: '#888888',
    },
    line: {
      main: '#4C4C4C',
    },
    icon: {
      navi: '#787878',
    },
    up: {
      main: '#00EF8B'
    }
  },
  typography: {
    allVariants: {
      color: '#F9F9F9',
    },
    fontFamily: ['Inter', 'sans-serif'].join(','),
    h1: {
      fontFamily: 'Montserrat,sans-serif',
      fontWeight: 'Bold',
    },
    h2: {
      fontFamily: 'Montserrat,sans-serif',
      fontWeight: 'Bold',
    },
    h3: {
      fontFamily: 'Montserrat,sans-serif',
      fontWeight: 'Bold',
    },
    h4: {
      fontFamily: 'Montserrat,sans-serif',
      fontWeight: 'Bold',
    },
    h5: {
      fontFamily: 'Montserrat,sans-serif',
      fontWeight: 'Bold',
    },
    h6: {
      fontFamily: 'Montserrat,sans-serif',
      fontWeight: 'Bold',
    },
    body1: {
      fontFamily: 'Inter,sans-serif',
    },
    overline: {
      fontFamily: 'Inter,sans-serif',
      textTransform: 'none',
    },
    caption: {
      fontFamily: 'Inter,sans-serif',
    },
    subtitle1: {
      fontFamily: 'Montserrat,sans-serif',
      fontWeight: 600
    }
  },
});

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    info3: true;
  }
}


export default theme;
